export default __webpack_public_path__ + "media/images/react_icons/comment_heart-4e657730b5bf3ba774f8ec41f3366e97.svg";